/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type EnumTagSemanticoDTOAggregazione =
  (typeof EnumTagSemanticoDTOAggregazione)[keyof typeof EnumTagSemanticoDTOAggregazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTagSemanticoDTOAggregazione = {
  UNIVOCA: 'UNIVOCA',
  CONCATENAZIONE: 'CONCATENAZIONE',
  SOMMA: 'SOMMA',
  MEDIA_ARITMETICA: 'MEDIA_ARITMETICA',
  MASSIMO: 'MASSIMO',
  MINIMO: 'MINIMO',
} as const;
